import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
import { useURL } from "@hooks/useURL"
import { motion, AnimatePresence } from "framer-motion"
import { wrap } from "@popmotion/popcorn";
import { useGtm } from "@hooks/useGtm"
import css from "@css/components/blocks/IndexSct03.module.styl"

const variants = {
    enter: (direction) => {
      return {
        // x: direction > 0 ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      zIndex: 1,
    //   x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        // x: direction < 0 ? 1000 : -1000,
        opacity: 0
      };
    }
  };
const swipeConfidenceThreshold = 10000
const swipePower = (offset, velocity) => {
    return Math.abs(offset) * velocity;
}

const Photos = ({q}) => {
    const [[page, direction], setPage] = React.useState([0, 0]);
    const images = [
        q.photo01.childImageSharp.fluid,
        q.photo02.childImageSharp.fluid,
        q.photo03.childImageSharp.fluid,
        q.photo04.childImageSharp.fluid,
        q.photo05.childImageSharp.fluid,
    ]
    const filters = [
        {
            img: q.filter01.childImageSharp.fluid,
        },{
            img: q.filter02.childImageSharp.fluid,
        },{
            img: q.filter03.childImageSharp.fluid,
        },{
            img: q.filter04.childImageSharp.fluid,
        },{
            img: q.filter05.childImageSharp.fluid,
        }
    ]
    const spfilters = [
        {
            img: q.spfilter01.childImageSharp.fluid,
        },{
            img: q.spfilter02.childImageSharp.fluid,
        },{
            img: q.spfilter03.childImageSharp.fluid,
        },{
            img: q.spfilter04.childImageSharp.fluid,
        },{
            img: q.spfilter05.childImageSharp.fluid,
        }
    ]
    const imageIndex = wrap(0, images.length, page)
    const paginate = (newDirection) => {
        setPage([page + newDirection, newDirection]);
    }
    // React.useEffect(()=>{
    //     setPage([selectId,selectId])
    // },[selectId])

    const gtm = useGtm()
    const handler = (page) => {
        gtm.push(['FireEvent','arrows5G Adobe','click',page[0]])
        setPage(page)
    }
    
    return(
        <div className={css.slider}>
            <div className={css.inner}>
                <div className={css.base}>
                    <Image fluid={q.photo01.childImageSharp.fluid}/>
                </div>
                <div className={css.photos}>
                    { images.map( ( fluid , i ) => {
                        return(
                            <div className={css.item} key={i} style={{opacity: imageIndex !== i ? 0 : 1}}>
                                <Image fluid={fluid} />
                            </div>
                        )
                    }) }
                </div>
                <div className="pc">
                    <div className={css.filters}>
                        { filters.map( ({img}, i ) => {
                            return(
                                <div className={`${css.item} ${i === page ? css.current : null}`} key={i} onClick={()=>{handler([i,i])}}>
                                    <Image fluid={img}/>
                                </div>
                            )
                        }) }
                    </div>
                </div>
                <div className="sp">
                    <div className={css.filters}>
                        { spfilters.map( ({img}, i ) => {
                            return(
                                <div className={`${css.item} ${i === page ? css.current : null}`} key={i} onClick={()=>{handler([i,i])}}>
                                    <Image fluid={img}/>
                                </div>
                            )
                        }) }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default function IndexHero()
{
    const q = useStaticQuery(graphql`
        query {
            photo01: file(relativePath: { eq: "Sct03__img__filter-photo-01@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            photo02: file(relativePath: { eq: "Sct03__img__filter-photo-02@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            photo03: file(relativePath: { eq: "Sct03__img__filter-photo-03@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            photo04: file(relativePath: { eq: "Sct03__img__filter-photo-04@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            photo05: file(relativePath: { eq: "Sct03__img__filter-photo-05@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 833) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            filter01: file(relativePath: { eq: "Sct03__img__filter-thumbnail-01@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            filter02: file(relativePath: { eq: "Sct03__img__filter-thumbnail-02@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            filter03: file(relativePath: { eq: "Sct03__img__filter-thumbnail-03@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            filter04: file(relativePath: { eq: "Sct03__img__filter-thumbnail-04@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            filter05: file(relativePath: { eq: "Sct03__img__filter-thumbnail-05@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }

            spfilter01: file(relativePath: { eq: "SpSct03__img__filter-thumbnail-01@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            spfilter02: file(relativePath: { eq: "SpSct03__img__filter-thumbnail-02@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            spfilter03: file(relativePath: { eq: "SpSct03__img__filter-thumbnail-03@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            spfilter04: file(relativePath: { eq: "SpSct03__img__filter-thumbnail-04@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            spfilter05: file(relativePath: { eq: "SpSct03__img__filter-thumbnail-05@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 157) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
        }
    `)

    const urls = useURL()
    return pug`
        div(className=${css.container})
            div(className=${css.inner})
                h2(className=${css.title})
                    span もっと
                    span いい感じにしたい？
                    br
                    span かんたんにできます。
                ${Photos({q})}
                p(className=${css.text})
                    |Photoshop Expressアイコンをおせば、直前に撮った写真をそのまま編集できます。
                    br
                    |指先１つであやつるデジタルスタジオを始めましょう。
            
        `
}
